import axios from "axios";
const CREATE = "/doors/create";

export const createDoors = async (data) => {
  try {
    console.log(data)
    await axios
      .post(`${CREATE}`, data)
      .then((res) => {
        //store.dispatch({ type: "CREATE_EXPENSES", data: res.data.data });
      })
      .catch((e) => {
        console.log(e)
        throw e;
      });
  } catch (e) {
    throw e;
  }
};
